import React from "react";
import PeriodFilter from "../components/PeriodFilter";
import config from "@config";

const TicketNewHeader = function (props) {
  const { period, onPeriod, onNewCase } = props;

  return (
    <header className="tn-header">
      <div className="tn-header-identity">
        <span className="tn-logo" aria-hidden="true">
          S
        </span>
        <div>
          <h1 className="tn-header-title">
            RMA Portal <span className="tn-header-title-muted">/ Cases</span>
          </h1>
          <p className="tn-header-subtitle">
            Service &amp; returns · Subemo {config.country.toUpperCase()}
          </p>
        </div>
      </div>

      <div className="tn-header-actions">
        <PeriodFilter value={period} onChange={onPeriod} />
        <button
          type="button"
          className="tn-btn tn-btn-primary"
          onClick={onNewCase}
        >
          + New case
        </button>
      </div>
    </header>
  );
};

export default TicketNewHeader;
